import { htmlToText } from '@/shared/lib/string/html-to-text'
import type { DigitalProduct } from '@/types/digitalProduct'

const DEFAULT_TAGLINE =
  'Participe de desafios, ganhe recompensas e suba no ranking do evento.'

const toPlainText = (value?: string | null) => htmlToText(value)

const truncate = (text: string, max = 140) =>
  text.length > max ? `${text.slice(0, max - 1)}…` : text

export function resolveAuthTagline(digitalProduct?: DigitalProduct): string {
  const short = toPlainText(digitalProduct?.short_description)
  if (short) {
    return truncate(short)
  }

  return DEFAULT_TAGLINE
}
